import React from 'react';
import { HStack, VStack } from 'native-base';
import { useSelector, useDispatch } from 'react-redux';
import CustomSwitch from '../../../../../common/CustomSwitch';
import AppText from '../../../../../common/AppText';
import { GlobalStyleAttributes } from '../../../../../../styles/GlobalStyles';
import { t } from '../../../../../../services/i18n';
import { isMobile } from '../../../../../../services/Helpers';
import InfoTooltip from '../../../../../common/InfoTooltip';
import { fetchApi } from '../../../../../../services/HTTP';
import { toggleScheduleLoader, toggleSuccessFlag } from '../../../../../../redux/ScheduleSlice';
import { DOCTOR_JOURNAL_SETTINGS } from '../../../../../../services/ConstHelper';
import { updateBox } from '../../../../../../redux/boxSlice';

const DoctorJournalSetting = (props) => {
    const { values, setFieldValue } = props;
    const dispatch = useDispatch();
    const box = useSelector((state) => state.box.box);
    const isEnabled = values?.doctorJournalEnabled ?? box?.settings?.doctor_journal_settings?.enabled ?? false;
    const alreadyEnabled = !!box?.settings?.doctor_journal_settings?.enabled;

    const toggle = async (val) => {
        console.log('val', val);
        if (alreadyEnabled) return;
        setFieldValue('doctorJournalEnabled', val);
        if (isMobile) {
            try {
                dispatch(toggleScheduleLoader(true));
                const setting = { prop_name: DOCTOR_JOURNAL_SETTINGS, properties: { enabled: !!val } };
                await fetchApi('boxes/settingsSchedule', 'POST', { boxes_settings: [setting] }, false, true);
                dispatch(toggleScheduleLoader(false));
                dispatch(toggleSuccessFlag(true));
                dispatch(updateBox({
                    settings: {
                        ...box.settings,
                        [DOCTOR_JOURNAL_SETTINGS]: setting.properties
                    }
                }));
            } catch (error) {
                console.log('error', error);
                dispatch(toggleScheduleLoader(false));
            }
        }
    };

    return (
        <VStack space="1rem">
            <HStack justifyContent="space-between" alignItems="center">
                <HStack alignItems="center" space="1">
                    <AppText fontSize={GlobalStyleAttributes.fonts.standard16} boldFont>{t('doctorJournalToggle')}</AppText>
                    {alreadyEnabled && <InfoTooltip title={t('doctorJournalCannotDisableTooltip')} />}
                </HStack>
                <CustomSwitch
                    isChecked={!!isEnabled}
                    onToggle={toggle}
                    disabled={alreadyEnabled}
                    style={{ width: isMobile && 'inherit' }}
                />
            </HStack>
            {!isMobile && <AppText fontSize={GlobalStyleAttributes.fonts.standard16} color="#666">{t('doctorJournalToggleDesc')}</AppText>}
        </VStack>
    );
};

export default DoctorJournalSetting;
